import '../styles/Footer.css';
import { FaFacebookF, FaLinkedinIn, FaYoutube } from 'react-icons/fa';
import logo from '../Assets/Images/Akij-Insaf-logo.png';
import footerWave from '../Assets/Images/footer.JPG'; // ✅ Add your wave image path

export default function Footer() {
  return (
    <>
      {/* Wave image at the top of the footer */}
      <div className="footer-wave-image">
        <img src={footerWave} alt="Footer Wave" />
      </div>

      <footer className="footer">
        <div className="footer-container">
          <div className="footer-left">
            <div className="footer-logo">
              <img src={logo} alt="Akij Insaf Group" />
              <h3>AKIJ INSAF GROUP</h3>
            </div>
            <div className="footer-copy">
              <p>Akij House, 198 Bir Uttam Mir Shawkat Sarak,Tejgaon, Dhaka 1208</p>
              
              <p>COPYRIGHT © {new Date().getFullYear()} AKIJ INSAF GROUP</p>
              <a href="#">Privacy Policy</a>
            </div>
          </div>

          <div className="footer-links">
            <div>
              <a href="#about">About Akij INSAF</a>  
              <a href="#businesses">Diverse Businesses</a>
              <a href="#brands">Pride Brands</a>
              <a href="#video">Watch Video</a>
            </div>
            <div>
              <a href="#evolution">Evolution of Akij</a>
              <a href="#founder">Honorable Founder</a>
              <a href="#md">Revered Managing Director</a>
              <a href="#director">Respected Director</a>
            </div>
            <div>
              <a href="#team">Leadership Team</a>
              <a href="#events">Events</a>
              <a href="#certifications">Prestigious Certifications</a>
              <a href="#achievements">Achievements</a>
            </div>
          </div>

          <div className="footer-social">
            <a href="#"><FaFacebookF /></a>
            <a href="#"><FaLinkedinIn /></a>
            <a href="#"><FaYoutube /></a>
          </div>
        </div>

        <div className="footer-scroll-top">
          <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>↑</button>
        </div>
      </footer>
    </>
  );
}
